import src from "IMAGE";
export default { src, width: 344, height: 203, blurWidth: 0, blurHeight: 0};
